import dayjs from 'dayjs';

/**
 * Set the browser favicon from the runtime tenant config, reusing the existing
 * `<link rel="icon">` if present. Cache-busted with a daily version query.
 * No-op when the config carries no favicon.
 */
export const applyFavicon = (uri?: string) => {
  if (!uri) {
    return;
  }
  const selector = 'link[rel~="icon"]';
  let link = document.querySelector<HTMLLinkElement>(selector);
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = `${uri}?v=${dayjs().format('YYYYMMDD')}`;
};
